import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Doctor.css";
const SetionTwo = () => {
  return (
    <div className="doctor_main_Cpnt">
      <Container>
        <Row>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/rhino.jpg"
/>{" "}
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Nose surgery ( Rhinoplasty or septoplasty)</a>
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/hair.jpeg"
/>{" "}
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Hair Transplant</a>
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/ortho-11.jpeg"
/>{" "}
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Opthalmology</a>
                </h3>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/glyco.jpeg"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Gynaecology</a>
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/skin.jpeg"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Skin</a>
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/face.jpeg"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Face</a>
                </h3>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
                      src="https://img.freepik.com/free-photo/young-beautiful-woman-with-perfect-body-black-underwear-sitting-floor-isolated-white-wall_231208-8949.jpg?t=st=1737311326~exp=1737314926~hmac=003666cf30e7d3ff9558c1ad323319a4f3ca3055c156ad81fba7b305f73929bb&w=360"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Body</a>
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/breast.jpeg"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Breast</a>
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/Liposuction.jpeg"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Liposuction</a>
                </h3>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/lipoma.jpeg"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Lipoma Removal</a>
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={4} md={8} xs={12} className="doctor_section_cols">
            <div className="post-item-wrap">
              <div className="post-thumbnail-wrap">
                <a>
                  <div className="post-thumbnail">
                    <img
                      className="section_doctor-ttwo_images"
src="/Images/gynecosmetia.jpeg"
                      alt=""
                    />
                  </div>
                </a>
              </div>
              <div className="post-infoss">
                <h3 className="post-titless">
                  <a>Gynecomastia</a>
                </h3>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SetionTwo;
